//import node packages
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {change} from 'redux-form'

//import utility functions
import {
  isMobileViewport,

  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../utilities/function/common'

import {
  getOrderingFlowType
} from '../../../utilities/function/configuration'

import {
  getCID,
  getDataFromURL,
  getCurrentStep
} from '../../../utilities/function/urlparams'

import {
  getAttributes,
  isConfigurationAdded,
  isFirstInvoicePromo,
  getServiceTypeFromProductConfig,
  getPurchasedDomainFromProductConfig,
  getPurchasedDomainPrice,
  getProductLabel,
  hasAddonInProductConfiguration
} from '../../../utilities/function/configuration'

import {
  getPriceByBillingCycleID,
  getPriceByBillingCycleName,
  getBillingCycleDataFromProductConfig,
  getCycle,
  getPriceListAfterDiscount
} from '../../../utilities/function/billingCycle'

import {
  getIconSlugBasedOnServiceType,
  getConfigName
} from '../../../utilities/function/manageServiceTypes'

import { updateConfig } from '../../../app/action'
import {EMAIL_HOSTING_TYPE, VPS_TYPE} from "../../../utilities/function/servicetype"
import {CUSTOM_HOSTING_FLOW} from "../../../utilities/function/productFlow"

//import shared components
import SimpleCheckbox from '../form/checkbox/simple'
import Ellipsis from "../ellipsis"

//define internal components
function ConfigurationItem (props) {
  const { label, value, onClick, isEnabled,className } = props
  return (
    <div
      className={`${className?' '+className:''}${isEnabled ? 'of-product-configuration-item--clickable ' : ''}of-product-configuration-item side-panel-background-2-100`}
      onClick={onClick || null}>
      <div className='of-product-configuration-item__label text-font-5-100'>{label}</div>
      <div className='of-product-configuration-item__value'>{value}</div>
    </div>
  )
}

ConfigurationItem.propTypes = {
  label: PropTypes.any,
  value: PropTypes.any,
  onClick: PropTypes.func,
  isEnabled: PropTypes.bool,
  className: PropTypes.string
}

function ConfigurationsAddons (props) {
  const { productConfig, onClick } = props
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const { SelectAdditionalOptionsForm } = useSelector(state => ({
    SelectAdditionalOptionsForm: state.form.SelectAdditionalOptionsForm
  }))
  if (productConfig) {
    const { addons, selectedProduct, billing_cycle_id } = productConfig
    const getBillingCyleName = () => {
      if(getAttributes(selectedProduct)){
        const {price} = getAttributes(selectedProduct)
        const selected = getPriceByBillingCycleID(price,billing_cycle_id)
        return selected && selected.name
      }

    }
    if (addons && Object.keys(addons).length) {
      addons.sort((a, b) => a.id - b.id)
      const renderList = () => {
        return addons.map((item) => {
          const id = item.id
          const getAddon = () => {
            if (selectedProduct && selectedProduct.attributes) {
              const { attributes } = selectedProduct
              const addonList = attributes.addons
              const getAddonObj = () => {
                if (addonList && addonList.length > 0) {
                  return addonList.find(item => item.id === id)
                }
                return null
              }
              if (getAddonObj()) {
                const { name, price,discount_price } = getAttributes(getAddonObj())
                const  priceList = discount_price? discount_price: price
                const getBillingCyclePice = getPriceByBillingCycleID(priceList, billing_cycle_id)
                if (getBillingCyclePice) {
                  const renderPrice = () => {
                    if (getBillingCyclePice && getBillingCyclePice.price) {
                      if (getBillingCyclePice.price === '0.00') {
                        return (<span className='free status-font-1-100'>FREE</span>)
                      }
                      return (<>${parseFloat(getBillingCyclePice.price)?parseFloat(getBillingCyclePice.price).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS):''}</>)
                    }
                    return (<></>)
                  }
                  return {
                    name,
                    price: renderPrice()
                  }
                }
              }
            }
            return {}
          }
          const addon = getAddon()
          const addonCallback = () => {
            if (SelectAdditionalOptionsForm && SelectAdditionalOptionsForm.values && id) {
              const currentVal = SelectAdditionalOptionsForm.values[`addon-${id}`]
              dispatch(change('SelectAdditionalOptionsForm', `addon-${id}`, !currentVal))
            }
          }
          return (<div className='of-product-configuration-addons__item of-product-configuration-item' key={id}>
            <div className='of-product-configuration-item__label text-font-5-100'>
              <SimpleCheckbox
                className='of-product-configuration-addons-checkbox'
                label={addon.name}
                value={true}
                readOnly={true}
                callback={addonCallback}
              />
            </div>
            <div className='of-product-configuration-item__value'>{addon.price}{getCycle(getBillingCyleName())}</div>
          </div>)
        })
      }
      const getAddonTotal = () => {
        let total = 0
        let old_total = 0
        addons.forEach(addon => {
          if (productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)) {
            const { addons } = getAttributes(productConfig.selectedProduct)
            if (addons && addons.length > 0) {
              const selectedAddon = addons.find(i => i.id === addon.id)
              if (selectedAddon && getAttributes(selectedAddon)) {
                const {price,discount_price} = getAttributes(selectedAddon)
                const priceList = discount_price? discount_price : price
                const selectedPrice = getPriceByBillingCycleID(priceList, billing_cycle_id)
                if (selectedPrice && selectedPrice.price && parseFloat(selectedPrice.price)) {
                  total += parseFloat(selectedPrice.price)
                }
                if(discount_price){
                  const oldPrice = getPriceByBillingCycleID(price, billing_cycle_id)
                  if (oldPrice && oldPrice.price && parseFloat(oldPrice.price)) {
                    old_total += parseFloat(oldPrice.price)
                  }
                }
              }
            }
          }
        })


        if (total > 0) {
          const renderPrice = () =>{
            if(old_total){
              return (<div className={'of-product-configuration-on-sale'}>
                <div className={'of-product-configuration-on-sale__old-price text-font-4-100'}>${old_total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}{getCycle(getBillingCyleName())}</div>
                <div className={'of-product-configuration-on-sale__sale-price'}>
                  <span>{getBillingCyleName()}</span> - <span className={'status-font-3-100'}>${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}{getCycle(getBillingCyleName())}</span></div>
              </div>)
            }
            return (
                <div className={'of-product-configuration-subtotal__price'}>
                  ${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}{getCycle(getBillingCyleName())}
                </div>
            )
          }
          const renderTerms = () => {
             if(old_total){
               return (<div className={'of-product-configuration-subtotal__terms text-font-4-100'}>(${old_total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}{getCycle(getBillingCyleName())} after the first invoice)</div>)
             }
             return (<></>)
          }
          return(<div className='of-product-configuration-item__value of-product-configuration-subtotal'>
                {renderPrice()}
                {renderTerms()}
          </div>)
        }
        return null
      }

      return (<div className='of-product-configuration-addons'>
        <div className='of-product-configuration-addons__top of-product-configuration-item side-panel-background-2-100'
             onClick={() => {
               onClick()
               setIsOpen(!isOpen)
             }}>
          <div className='of-product-configuration-addons__label of-product-configuration-item__label text-font-5-100'>
            Addons
            <div
              className={`of-product-configuration-addons__arrow${isOpen ? ' of-product-configuration-addons__arrow--open' : ''}`}>
              <i className={`icon icon-of-arrow`}/>
            </div>
          </div>
          {getAddonTotal()}
        </div>
        {isOpen ? <div
          className='of-product-configuration-addons__bottom side-panel-background-2-100 lines-border-1-10'>
          {renderList()}
        </div> : <></>}
      </div>)
    }
  }
  return (<></>)
}

ConfigurationsAddons.propTypes = {
  productConfig: PropTypes.any,
  onClick: PropTypes.func
}


//main component
let ProductSidebar = (props) => {
  //define variables
  const {
    configurations,
    viewport
  } = useSelector(state => ({
    configurations: state.app.configurations,
    form: state.form,
    viewport: state.app.viewport,
    cartData: state.app.cartData
  }))
  const { location } = props
  const { a } = getDataFromURL(location.search)
  const cid = getCID(getDataFromURL(location.search))
  const productConfig = configurations[cid]
  const dispatch = useDispatch()

  //define functions
  const panelItemOnClick = (label) => {
    const { breadcrumbs } = productConfig
    if (breadcrumbs && breadcrumbs.length) {
      const billingCycleStep = breadcrumbs.find(item => item.label === label)
      if (billingCycleStep) {
        updateConfig(configurations, cid, { step: billingCycleStep.itemStep }, dispatch)
      }
    }
  }

  //define render functions
  const renderProductName = () => {
    const getProductName = () => {
      if (productConfig && getAttributes(productConfig.selectedProduct)) {
        const { name, service_type } = getAttributes(productConfig.selectedProduct )
        return getProductLabel(name,service_type)
      }
      return null
    }
    const getIcon = () => {
      if (productConfig && getAttributes(productConfig.selectedProduct)) {
        return (<div className='of-product-configuration__icon primary-background-1-100'><i
          className={`icon icon-of-${getIconSlugBasedOnServiceType(productConfig)}`}/></div>)
      }
      return (<></>)
    }
    return (
      <div className='of-product-configuration'>
        <div className='of-product-configuration__name side-panel-background-2-100'>
          {getIcon()}
          <div className='of-product-configuration__text'>{getProductName()}</div>
        </div>
      </div>
    )
  }
  const renderBillingCycle = () => {
    const billingCycleIDKey = Object.keys(productConfig).find(item => item === 'billing_cycle_id')
    const getPrice = () => {
      const productList = getBillingCycleDataFromProductConfig(productConfig)
      if (productList && productList.length) {
        let selectedPrice = null
        if (billingCycleIDKey) {
          selectedPrice = getPriceByBillingCycleID(productList, productConfig[billingCycleIDKey])
        }else{
          selectedPrice = getPriceByBillingCycleName(productList, 'Monthly')
        }
        return (selectedPrice)
      }
      return (null)
    }
    const selectedPrice = getPrice()
    if (selectedPrice) {
      let { name, price } = selectedPrice
      if(price){
        price = price.replace(",","")
      }
      const getValue = () => {
        if (price && parseFloat(price) >= 0) {
          const oldPriceList = getBillingCycleDataFromProductConfig(productConfig,true)
          const getOldPrice = () => {
            if(oldPriceList && oldPriceList.length){
              const selected = getPriceByBillingCycleID(oldPriceList,productConfig.billing_cycle_id)
              return selected ? selected.price : null
            }
          }
          const onSale = () => {
            if(price!==getOldPrice()){
              return true
            }
            return false
          }
          const renderPriceValue = () =>{
            const price_string = parseFloat(price).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
            if(price_string){
              if(price_string ==="0.00"){
                return name
              }
              if(onSale()){
                return (<div className={'of-product-configuration-on-sale'}>
                  <div className={'of-product-configuration-on-sale__old-price text-font-4-100'}>${getOldPrice()}{getCycle(name)}</div>
                  <div className={'of-product-configuration-on-sale__sale-price'}>
                    <span>{name}</span> - <span className={'status-font-3-100'}>${price_string}{getCycle(name)}</span></div>
                </div>)
              }
              return (`${name} - $${price_string}${getCycle(name)}`)
            }
            return (<></>)
          }
          if(isFirstInvoicePromo(productConfig)){
            if(onSale()){
              return (
                  <div className={'of-product-configuration-item-firstinvoice'}>
                    <div className={'of-product-configuration-item-firstinvoice__price'}>{renderPriceValue()}</div>
                    <div className={'of-product-configuration-item-firstinvoice__description text-font-4-100'}>(${getOldPrice()}{getCycle(name)} after the first invoice)</div>
                  </div>
              )
            }

          }
          return (
              <>{renderPriceValue()}</>
          )
        }
        return (name)
      }
      return (
        <ConfigurationItem isEnabled={true} label='Billing Cycle' value={getValue()}
                           onClick={() => {panelItemOnClick('Billing Cycle')}} />
      )
    }
    return (<></>)
  }
  const renderQuantity = () => {

    if(productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)){
      const {is_quantity_based} = getAttributes(productConfig.selectedProduct)
      const {quantity} = productConfig
      if(is_quantity_based && quantity){
        const serviceType = getServiceTypeFromProductConfig(productConfig);
        if(serviceType===EMAIL_HOSTING_TYPE){
          return (
              <ConfigurationItem isEnabled={true} label='Mailboxes' value={quantity}
                                 onClick={() => {panelItemOnClick('Mailboxes')}} />
              )
        }
        return (<ConfigurationItem isEnabled={true} label='Quantity' value={quantity}
                                   onClick={() => {panelItemOnClick('Quantity')}} />)
      }
    }

    return (<></>)
  }
  const renderDomainName = () => {
    const nameIDKey = Object.keys(productConfig).find(item => item === 'name')
    if (nameIDKey && productConfig[nameIDKey]) {
      const purchasedDomain =  getPurchasedDomainFromProductConfig(productConfig,configurations)
      const purchaseDomainPrice = getPurchasedDomainPrice(purchasedDomain)
      const renderPurchasedDomainName = () => {
        if(purchaseDomainPrice && purchaseDomainPrice.type && purchaseDomainPrice.price && purchaseDomainPrice.name){
          const {type,price,name} = purchaseDomainPrice
          const renderPrice = () => {
            if(price==='0.00'){
              return (
                <div className={'of-purchased-domain-name__price-value of-purchased-domain-name__price-value--free status-font-1-100'}>FREE</div>
              )
            }
            return (
              <div className={'of-purchased-domain-name__price-value'}>${price}</div>
            )
          }
          const renderName = () => {
            if(type==="register"){
              return (<div className={'of-purchased-domain-name__price-name'}>{name} - </div>)
            }
            return (<></>)
          }
          return (
            <div className={`of-product-configuration-item of-purchased-domain-name side-panel-background-2-100`}>
              <div className={`of-purchased-domain-name__box text-border-4-40 text-font-4-100`}>
                <div className={`of-purchased-domain-name__type`}>{type}</div>
                <div className={`of-purchased-domain-name__price`}>
                  {renderName()}
                  {renderPrice()}
                </div>
              </div>
            </div>
          )
        }
        return (<></>)
      }
      const renderConfigurationItem = () => {
        const type = getServiceTypeFromProductConfig(productConfig)

        const renderEllipsis = () => {
          const domainName = productConfig[nameIDKey]
          const renderFormat = () => {
            const first = domainName.substring(0,10)
            const last = domainName.substring(domainName.length - 10)
            return (<>{first}...{last}</>)
          }
          if(domainName){
            return (
                <Ellipsis tooltip={domainName} isActive={domainName && domainName.length > 32} format={renderFormat()} >
                  {domainName}
                </Ellipsis>
            )
          }
          return (<></>)
        }

        if(type===VPS_TYPE){
          return(
              <ConfigurationItem className={purchasedDomain?' of-product-configuration-item--purchased-domain':''} isEnabled={true} label='Hostname' value={renderEllipsis()}
                                 onClick={() => { panelItemOnClick('Resources')}} />
          )
        }
        return (
            <ConfigurationItem className={purchasedDomain?' of-product-configuration-item--purchased-domain ':''} isEnabled={true} label='Domain' value={renderEllipsis()}
                               onClick={() => { panelItemOnClick('Domain Name')}} />
        )
      }
      return (<>
        {renderConfigurationItem()}
        {renderPurchasedDomainName()}
        </>
      )
    }
    return (<></>)
  }
  const renderConfigOptions = () => {
    const configIDKey = Object.keys(productConfig).find(item => item === 'config')
    if (configIDKey && productConfig[configIDKey]) {
      const config = productConfig[configIDKey]
      const product = productConfig['selectedProduct']
      if (config && config.length > 0 && getAttributes(product)) {
        const { config_options } = getAttributes(product)
        if (config_options && config_options.length) {
          return config.map((item, index) => {
            const { config_id, option_id,quantity } = item
            const selectedConfig = config_options.find(item => item.id === config_id)
            if (selectedConfig) {
              const { name, options } = selectedConfig
              const selectedOption = options && options.length > 0 ? options.find(item => item.id === option_id) : null
              const getValue = () => {
                if (selectedOption) {
                  const { billing_cycle_id } = productConfig
                  const { price, name,discount_price } = selectedOption
                  const priceList = getPriceListAfterDiscount(price,discount_price)
                  let priceItem = getPriceByBillingCycleID(priceList, billing_cycle_id)
                  if(billing_cycle_id ===undefined){
                    priceItem = getPriceByBillingCycleName(price, 'Monthly')
                  }
                  if (priceItem && priceItem.price) {
                    if( parseFloat(priceItem.price) > 0){
                      return (<>{quantity?quantity+' ':''}{getConfigName(name)} - ${parseFloat(priceItem.price).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}{getCycle(priceItem.name)}</>)
                    }
                    if(parseFloat(priceItem.price) === 0){
                      return (<>{quantity?quantity+' ':''}{getConfigName(name)} - <span className={'free'}>Free</span></>)
                    }
                  }
                }
                return (<></>)
              }

              let enabled = true
              if(productConfig && productConfig.selectedProduct && !isConfigurationAdded(productConfig)){
                const {id} = productConfig.selectedProduct
                const flowType = getOrderingFlowType(id)
                if(flowType===CUSTOM_HOSTING_FLOW){
                  enabled = false
                }
              }
              return (
              <ConfigurationItem isEnabled={enabled} key={index} label={name} value={getValue()}
                                   onClick={() => {
                                     panelItemOnClick('Resources')
                                   }}/>)
            }
            return (<div key={index}></div>)
          })
        }
      }
    }
    return (<></>)
  }
  const renderTotalSection = () => {
    let total = undefined
    if (productConfig) {
      const { billing_cycle_id, selectedProduct, addons, config, quantity } = productConfig
      if (selectedProduct && selectedProduct.attributes && selectedProduct.id) {
        const { attributes } = selectedProduct
        total = 0
        const addServicePrice = () => {
            const { price, discount_price } = attributes
            let servicePrice = getPriceByBillingCycleID(price, billing_cycle_id)
            if (discount_price && discount_price.length > 0) {
              servicePrice = getPriceByBillingCycleID(discount_price, billing_cycle_id)
            }
            if (servicePrice) {
              total += parseFloat(servicePrice.price)
            }
        }
        const addDomainPrice = () =>{
          const purchasedDomain =  getPurchasedDomainFromProductConfig(productConfig,configurations)
          const purchaseDomainPrice = getPurchasedDomainPrice(purchasedDomain)
          if(purchaseDomainPrice && purchaseDomainPrice.type && purchaseDomainPrice.price){
            total += parseFloat(purchaseDomainPrice.price)
          }
        }
        const addAddonPrice = () => {
          if (addons && addons.length > 0) {
            addons.forEach(addonValue => {
              const getAddonItem = () => {
                const addonList = attributes.addons
                if (addonList && addonList.length) {
                  return addonList.find(addonData => addonData.id === addonValue.id)
                }
                return null
              }
              const addonItem = getAddonItem()
              if (addonItem && getAttributes(addonItem) && getAttributes(addonItem).price) {
                const {price,discount_price} = getAttributes(addonItem)
                const priceList = getPriceListAfterDiscount(price,discount_price)
                const addonPriceObj = getPriceByBillingCycleID(priceList, billing_cycle_id)
                if (addonPriceObj) {
                  total += parseFloat(addonPriceObj.price)
                }
              }
            })
          }

        }
        const addConfigPrice = () => {
          if (config && config.length > 0) {
            config.forEach(configValue => {
              const { config_id, option_id,quantity } = configValue
              const getConfigItem = () => {
                const configList = attributes.config_options
                if (configList && configList.length) {
                  return configList.find(configData => configData.id === config_id)
                }
                return null
              }
              const configItem = getConfigItem()
              if (configItem) {
                const option = configItem.options.find(item => item.id === option_id)
                if (option) {
                  const { price,discount_price } = option
                  const priceList = getPriceListAfterDiscount(price,discount_price)
                  let configPriceObj = getPriceByBillingCycleID(priceList, billing_cycle_id)
                  if(billing_cycle_id===undefined){
                    configPriceObj = getPriceByBillingCycleName(priceList, 'Monthly')
                  }
                  if (configPriceObj) {
                    if(quantity){
                      total += parseFloat(configPriceObj.price) * quantity
                    }else{
                      total += parseFloat(configPriceObj.price)
                    }
                  }
                }
              }
            })
          }
        }
        const addQuantity = () => {
          if(quantity){
            total = total * quantity
          }
        }

        addServicePrice()
        addDomainPrice()
        // addon
        if (hasAddonInProductConfiguration(productConfig)) {
          addAddonPrice()
        }
        addConfigPrice()
        addQuantity()
      }
    }
    if (total === undefined) {
      return (<></>)
    }

    const getShow = () => {
      let show = false
      const currentStep = getCurrentStep(configurations,cid)
      if (a === 'add') {
        if(currentStep){
          show = true
        }
      } else if (a === 'edit') {
        show = true
      }
      return show
    }
    if (getShow()) {
      return (<div className='of-sidebar-total'>
        <div className='of-sidebar-total__details'>
          <div className='of-sidebar-total__label'>Total Amount</div>
          <div className='of-sidebar-total__amount'>${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}</div>
        </div>
       {/* {renderButton()}*/}
      </div>)
    }
    return (<></>)
  }
  if (productConfig && !isMobileViewport(viewport)) {
    return (
      <aside className='of-sidebar side-panel-background-1-100'>
        <div className='of-sidebar__heading text-font-5-100'>Product Configuration</div>
        {renderProductName()}
        {renderBillingCycle()}
        {renderQuantity()}
        {renderConfigOptions()}
        {renderDomainName()}
        <ConfigurationsAddons productConfig={productConfig} onClick={() => {panelItemOnClick('Addons')}}/>
        {renderTotalSection()}
      </aside>
    )
  }
  return (<></>)
}

ProductSidebar.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}

ProductSidebar = withRouter(ProductSidebar)

export default ProductSidebar
